import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import Index from "./pages/Index.tsx";
import ResetPassword from "./pages/ResetPassword.tsx";
import NotFound from "./pages/NotFound.tsx";
import CardPage from "./pages/CardPage.tsx";
import SetPage from "./pages/SetPage.tsx";
import SetsIndexPage from "./pages/SetsIndexPage.tsx";
import RotationPage from "./pages/RotationPage.tsx";
import BannedPage from "./pages/BannedPage.tsx";
import PricesPage from "./pages/PricesPage.tsx";
import BroomDeckGuidePage from "./pages/BroomDeckGuidePage.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/cards/:slug" element={<CardPage />} />
            <Route path="/sets" element={<SetsIndexPage />} />
            <Route path="/sets/:slug" element={<SetPage />} />
            <Route path="/rotation" element={<RotationPage />} />
            <Route path="/banned" element={<BannedPage />} />
            <Route path="/prices" element={<PricesPage />} />
            <Route path="/guides/broom-deck" element={<BroomDeckGuidePage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>


      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
